import PropTypes from "prop-types";
import React from "react";

import ViewCheckIcon from "../../utils/Icons/ViewCheck";

const ViewReactivateButton = ({
  containerClassName,
  className,
  onClick,
  label
}) => {
  return (
    <div
      className={`${containerClassName} h-100 border-radius-8 primary-bg pointer padding-10 box-shadow-hover ${label ? "d-flex gap-2 align-items-center " : ""}`}
      onClick={onClick}>
      <ViewCheckIcon
        className={`table-icon action-icon  ${className}`}
      />
      <span className="text-white fweight-500 fsize-16 d-none d-md-block">
        {label}
      </span>
    </div>
  );
};

ViewReactivateButton.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string
};

export default ViewReactivateButton;
